import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { MessageListComponent } from '@tv3/containers/messages/message-list/message-list.component'
import { MessageListItemComponent } from '@tv3/containers/messages/message-list/message-list-item/message-list-item.component'
import { InquiryMessageFormComponent } from '@tv3/containers/messages/inquiry-message-form/inquiry-message-form.component'
import { EditorModule } from '@tinymce/tinymce-angular'
import { MessageListItemBaseComponent } from '@tv3/containers/messages/message-list/message-list-item-base/message-list-item-base.component'
import { InquiryLibModule } from '@tokeet-frontend/inquiry'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { OverlayModule } from '@angular/cdk/overlay'
import { MessageLibraryModule } from '@tokeet-frontend/message'
import { MessagingChannelSwitcherComponent } from './inquiry-message-form/components/messaging-channel-switcher/messaging-channel-switcher.component'
import { MessagingChannelContactsComponent } from './inquiry-message-form/components/messaging-channel-contacts/messaging-channel-contacts.component'

import { ConnectWhatsappDialogComponent } from './connect-whatsapp-dialog/connect-whatsapp-dialog.component'
import { InitialWhatsappDialogComponent } from './initial-whatsapp-dialog/initial-whatsapp-dialog.component'
import { InitialWhatsappDialogService } from './initial-whatsapp-dialog/initial-whatsapp-dialog.service'
import { ConnectWhatsappDialogService } from './connect-whatsapp-dialog/connect-whatsapp-dialog.service'
import { MessagingChannelHelperService } from './messaging-channel-helper.service'
import { ConnectInstagramDialogService } from './connect-instagram-dialog/connect-instagram-dialog.service'
import { ConnectInstagramDialogComponent } from './connect-instagram-dialog/connect-instagram-dialog.component'
import { ConnectFacebookDialogService } from './connect-facebook-dialog/connect-facebook-dialog.service'
import { ConnectFacebookDialogComponent } from './connect-facebook-dialog/connect-facebook-dialog.component'
import { SendWhatsappTemplateDialogService } from './send-whatsapp-template-dialog/send-whatsapp-template-dialog.service'
import { SendWhatsappTemplateDialogComponent } from './send-whatsapp-template-dialog/send-whatsapp-template-dialog.component'
import { ConnectGmailDialogService } from './connect-gmail-dialog/connect-gmail-dialog.service'
import { ConnectGmailDialogComponent } from './connect-gmail-dialog/connect-gmail-dialog.component'
import { IncidentLibraryModule } from '@tokeet-frontend/incident'
import { TasksLibModule } from '@tokeet-frontend/tasks'

const components = [
  MessageListComponent,
  InquiryMessageFormComponent,
  MessageListItemBaseComponent,
  MessageListItemComponent,
  MessagingChannelSwitcherComponent,
  MessagingChannelContactsComponent,
  ConnectWhatsappDialogComponent,
  InitialWhatsappDialogComponent,
  ConnectInstagramDialogComponent,
  ConnectFacebookDialogComponent,
  ConnectGmailDialogComponent,
  SendWhatsappTemplateDialogComponent,
]

const services = [
  //
  MessagingChannelHelperService,
  InitialWhatsappDialogService,
  ConnectWhatsappDialogService,
  ConnectInstagramDialogService,
  ConnectFacebookDialogService,
  ConnectGmailDialogService,
  SendWhatsappTemplateDialogService,
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EditorModule,
    InquiryLibModule,
    DragDropModule,
    OverlayModule,
    MessageLibraryModule,
    IncidentLibraryModule,
    TasksLibModule,
  ],
  declarations: [...components],
  exports: [...components],
  providers: [...services],
})
export class MessagesSharedModule {}
